import React, { CSSProperties } from 'react';
import HTMLParse from 'html-react-parser';

import IDHelpers from '../../../core/helpers/IDHelper';

import * as S from './styled';

interface IProps {
  isDecimal?: boolean;
  items: string[];
  style?: CSSProperties;
}

const ReusableList = ({ isDecimal, items, style }: IProps) => (
  <S.Wrapper isDecimal={isDecimal} style={{ ...style }}>
    {items.map((item) => (
      <li key={IDHelpers.generateID()}>{HTMLParse(item)}</li>
    ))}
  </S.Wrapper>
);

export default ReusableList;
